import isAchCompanyBalanced from './is-ach-company-balanced.js';

const doesAchCompanyAllowUnbalancedPayments = achCompany => {
    if (isAchCompanyBalanced(achCompany)) return false;
    return achCompany.allowUnbalancedPayments;
};

export default doesAchCompanyAllowUnbalancedPayments;
